module.exports = __webpack_public_path__ + "static/media/logo-black.04aa8a91.png";